import { type ContentBugReportBody, inquiryApi } from '@mathflat/domain/Inquiry'

import { mpEventInfo } from '@/constant'

class BugReportController {
  postErrorReportConcept = (data: ContentBugReportBody) =>
    inquiryApi.createContentBugReport('CONCEPT', data, { mp_event_name: mpEventInfo.유형신고 })

  postErrorReportLittleChapter = (data: ContentBugReportBody) =>
    inquiryApi.createContentBugReport('LITTLE_CHAPTER', data, {
      mp_event_name: mpEventInfo.유형신고,
    })

  postErrorReportPublicProblem = (data: ContentBugReportBody) =>
    inquiryApi.createContentBugReport('PUBLIC_PROBLEM', data, {
      mp_event_name: mpEventInfo.시중문제신고,
    })

  postErrorReportCustomProblem = (data: ContentBugReportBody) =>
    inquiryApi.createContentBugReport('PROBLEM', data, { mp_event_name: mpEventInfo.문제신고 })

  postErrorReportArithmetic = (data: ContentBugReportBody) =>
    inquiryApi.createContentBugReport('WORKSHEET', data, { mp_event_name: mpEventInfo.학습지신고 })
}

export const bugReportController = new BugReportController()
